// extracted by mini-css-extract-plugin
export default {"FileName":"_FileName--TCWYQ","FileNameExtensionSuffix":"_FileNameExtensionSuffix--OLYH1","FileNameSplitWithExtension":"_FileNameSplitWithExtension--PcOOw"};